module.exports = __webpack_public_path__ + "assets/img/ic-trash.dcb8dd5b.svg";